import { Box, Button, Flex, Typography } from '@iheartjane/reefer';

interface Props {
  embeddedMode: boolean;
  onCancel: () => void;
  onLogout: () => void;
}

export const LogoutForm = ({ onCancel, onLogout, embeddedMode }: Props) => (
  <Box py={embeddedMode ? 16 : 0}>
    <Typography branded mb={8} textAlign="center" variant="h2-semibold">
      Sign out?
    </Typography>
    <Typography color="grays-black" mb={24} textAlign="center">
      Shopping experience may be limited.
    </Typography>
    <Typography variant="body-semibold">
      <Flex justifyContent="space-around">
        <Button
          branded
          full
          variant="secondary"
          onClick={onCancel}
          label="Cancel"
          mr={16}
        />
        <Button
          branded
          full
          variant="destructive"
          onClick={onLogout}
          data-testid="Log Out-button"
          label="Sign out"
        />
      </Flex>
    </Typography>
  </Box>
);
